{
  "sidenavMenuCloseTooltip": "Cerrar menú",
  "sidenavMenuLockTooltip": "Haga clic para bloquear el menú",
  "toggleSideNav": "Alternar menú de navegación lateral"
}
